import { Facility, FacilityInfo } from './ApiTypes';

// Feature constants
export const FEATURES = {
    // Payment features
    ACH: 'ACHPayment',
    REQUIRE_LICENSE_PLATE: 'RequireLP', 
    ONE_TERM_PARKING: 'OneTermParking',
    USAGE_BASED_PLANS: 'UsageBasedPlans',
    ENHANCED_GROUPS: 'EnhancedGroups',
    TRANSIENT_PHONE_ALPR: 'TransientPhoneLpr',
    TRANSIENT_QR_SCAN: 'TransientQrCodeScanner',
    SUBSCRIPTION_FEES: 'SubscriptionFees',
} as const;

// Type for feature keys
export type FeatureKey = keyof typeof FEATURES;

/**
 * Checks if a specific feature is enabled for a facility
 * @param facility The facility to check
 * @param feature The feature to check for (use FEATURES constant)
 * @returns boolean indicating if the feature is enabled
 */
export function isFeatureEnabled(facility: Facility | FacilityInfo, feature: string): boolean {
    return facility.features.includes(feature);
}

/**
 * Checks if multiple features are enabled for a facility
 * @param facility The facility to check
 * @param features Array of features to check for (use FEATURES constant)
 * @returns boolean indicating if all features are enabled
 */
export function areFeaturesEnabled(facility: Facility, features: string[]): boolean {
    return features.every(feature => isFeatureEnabled(facility, feature));
}

/**
 * Gets all enabled features for a facility
 * @param facility The facility to check
 * @returns Array of enabled feature strings
 */
export function getEnabledFeatures(facility: Facility): string[] {
    return facility.features;
} 